import { createUseStyles } from 'react-jss';

import { FontSize, FontWeight } from '../../../styles';

function remSize(fontSize: FontSize) {
  return `${fontSize}rem`;
}

const titleFontOptions = { fontWeight: FontWeight.Bold, color: 'var(--x-accent-2-1)' };

const bodyFontOptions = {
  fontWeight: FontWeight.Regular,
  color: 'var(--x-text-color-1)',
};

const strongFontOptions = {
  fontWeight: FontWeight.SemiBold,
  color: 'var(--x-text-color-1)',
};

const useStyles = createUseStyles(
  {
    root: {
      // look styles
      '&.look-h1': {
        ...titleFontOptions,
        fontSize: remSize(FontSize.Size_9),
        lineHeight: '5rem',
      },
      '&.look-h2': {
        ...titleFontOptions,
        fontSize: remSize(FontSize.Size_8),
      },
      '&.look-h3': {
        ...titleFontOptions,
        fontSize: remSize(FontSize.Size_7),
      },
      '&.look-h4': {
        ...titleFontOptions,
        fontSize: remSize(FontSize.Size_6),
      },
      '&.look-h5': {
        ...titleFontOptions,
        fontSize: remSize(FontSize.Size_5),
      },
      '&.look-h6': {
        ...titleFontOptions,
        fontSize: remSize(FontSize.Size_4),
      },
      '&.look-p': {
        ...bodyFontOptions,
        fontSize: remSize(FontSize.Size_2),
      },
      '&.look-strong': {
        ...strongFontOptions,
        fontSize: remSize(FontSize.Size_2),
      },
      '&.look-span': {
        ...bodyFontOptions,
        fontSize: remSize(FontSize.Size_2),
      },
      '&.look-title': {
        fontSize: remSize(FontSize.Size_9),
        fontWeight: FontWeight.Black,
        color: 'var(--x-text-color-1)',
      },
      '&.look-subtitle': {
        fontSize: remSize(FontSize.Size_7),
        fontWeight: FontWeight.Bold,
        color: 'var(--x-text-color-2)',
      },
      '&.look-body': {
        ...bodyFontOptions,
        fontSize: remSize(FontSize.Size_2),
        lineHeight: '1.7143rem',
      },
      '&.look-body-large': {
        ...bodyFontOptions,
        fontSize: remSize(FontSize.Size_3),
      },
      '&.look-description': {
        fontSize: remSize(FontSize.Size_6),
        fontWeight: FontWeight.Regular,
        color: 'var(--x-text-color-2)',
      },
    },
  },
  {
    name: 'typography',
  },
);

export default useStyles;
